import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useThemeStore } from '../../store/useThemeStore';

/**
 * Toggle de tema oscuro / claro.
 * Usa tokens semánticos para verse correcto en ambos temas.
 * Muestra el ícono del tema AL QUE se cambiará (sol = ir a claro, luna = ir a oscuro).
 */
const ThemeToggle = ({ className = '', size = 18 }) => {
  const theme = useThemeStore((s) => s.theme);
  const toggleTheme = useThemeStore((s) => s.toggleTheme);
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      role="switch"
      aria-checked={isDark}
      aria-label={isDark ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'}
      title={isDark ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'}
      className={
        'flex items-center justify-center w-10 h-10 rounded-lg border border-line ' +
        'bg-surface-3 hover:bg-surface-4 text-content-secondary hover:text-content-primary ' +
        'transition-all duration-200 ' +
        className
      }
    >
      {isDark ? <Sun size={size} /> : <Moon size={size} />}
    </button>
  );
};

export default ThemeToggle;
